export default __webpack_public_path__ + "static/media/ic_dialog_close.e3d79032.svg";